import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import { Divider } from "@mui/material";
import React, { useEffect, useState } from "react";
import CoreButtonHoverIcon from "../../../app/core/components/CoreButtonIcon/CoreButtonHoverIcon.jsx";
import CoreButtonIcon from "../../../app/core/components/CoreButtonIcon/CoreButtonIcon.jsx";
import CoreSpinner from "../../../app/core/components/CoreSpinner/CoreSpinner.jsx";
import {
  useDoSetreadConversationMutation,
  useGetAllChatConversationQuery,
} from "../../api/admin/assistenteSmartApi.js";
import {
  useDoSetReadChatMutation,
  useGetUserAllChatConversationQuery,
} from "../../api/user/assistenteSmartApi.js";
import ChatBox from "./ChatBox.jsx";
import ListaChat from "./ListaChat.jsx";
import { t } from "i18next";
import ChatFilter from "./ChatFilter.jsx";
import { TABLE_ROWS_NUMBER } from "../../../utils/constants/tables.js";
import UserFilter from "../../../app/core/components/UserFilter/UserFilter.jsx";
import { useGetUsersQuery } from "../../api/admin/gestisciUtentiApi.js";
import { useGetPracticeManagementQuery } from "../../api/admin/gestisciPraticheApi.js";
import { useGetCommercialistaQuery } from "../../api/admin/gestisciCommercialistiApi.js";
import CoreChip from "../../../app/core/components/CoreChip/CoreChip.jsx";
import { labelForFilterChat } from "../../../utils/functions/filters.js";
import CoreTabBar from "../../../app/core/components/CoreTabBar/CoreTabBar.jsx";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { ROLE } from "../../../utils/constants/profiles.js";
import CorePagination from "../../../app/core/components/CorePagination/CorePagination.jsx";
import SettingsApplicationsRoundedIcon from "@mui/icons-material/SettingsApplicationsRounded";
import CoreModal from "../../../app/core/components/CoreModal/CoreModal.jsx";
import AutoMessage from "./AutoMessage.jsx";

const ChatPage = () => {
  const appConfig = useSelector((state) => state.app.appConfig);
  const role = useSelector((state) => state.app.role);
  const studioId = useSelector((state) => state.app.studioId);
  const userLocation = useLocation();
  const [selectedUser, setSelectedUser] = useState(
    userLocation ? userLocation?.state : ""
  );
  const [chat, setChat] = useState();
  const [openChat, setOpenChat] = useState(null);
  const [status, setStatus] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [debouncedInputOperatorValue, setDebouncedInputOperatorValue] =
    useState("");
  const [debouncedInputUserValue, setDebouncedInputUserValue] = useState("");
  const [debouncedInputPracticeValue, setDebouncedInputPracticeValue] =
    useState("");
  const [selectedTab, setSelectedTab] = useState("Generali");
  const [page, setPage] = useState({
    currentPage: 1,
    startRow: 0,
    endRow: TABLE_ROWS_NUMBER,
  });
  const [filter, setFilter] = useState({
    userId: "",
    adminId: "",
    practiceId: "",
    status: "",
  });
  // USER API
  const {
    data: chatUser,
    isLoading: isLoadingChatUser,
    refetch: refetchChatUser,
  } = useGetUserAllChatConversationQuery(studioId, {
    skip: !studioId || role !== ROLE.USER,
  });

  const [doSetreadUserConversation] = useDoSetReadChatMutation();

  // ADMIN API

  const {
    data: dataChat,
    isLoading: isLoadingChat,
    refetch: refetchChat,
  } = useGetAllChatConversationQuery(
    { page, filter },
    { skip: role === ROLE.USER }
  );
  const {
    data: usersData,
    isLoading: isUsersLoading,
    isFetching: isUsersFetching,
  } = useGetUsersQuery(
    {
      page: { startRow: 0, endRow: 10 },
      value: debouncedInputUserValue,
    },
    { skip: role === ROLE.USER },
    { refetchOnMountOrArgChange: true }
  );

  const {
    data: operatorsData,
    isFetching: isOperatorsFetching,
    isLoading: isOperatorsLoading,
  } = useGetCommercialistaQuery(
    {
      page: { startRow: 0, endRow: 10 },
      value: debouncedInputOperatorValue,
    },
    { skip: role === ROLE.USER }
  );

  const {
    data: practicesData,
    isLoading: practicesLoading,
    isFetching: practicesFetching,
  } = useGetPracticeManagementQuery(
    {
      page: { startRow: 0, endRow: 100 },
      userFilter: "",
      filter: {
        status: "",
        serviceId: "",
        studioId: "",
        adminId: "",
        companyId: "",
      },
      orderDirection: "asc",
      valueToOrderBy: "name",
      queryName: debouncedInputPracticeValue,
      showAll: true,
    },
    { skip: role === ROLE.USER }
  );

  const [doSetreadConversation] = useDoSetreadConversationMutation();

  useEffect(() => {
    if (role !== ROLE.USER && dataChat && dataChat.Data)
      setChat(dataChat?.Data?.items);
    if (role === ROLE.USER && chatUser && chatUser.Data)
      setChat(chatUser?.Data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataChat, chatUser]);

  useEffect(() => {
    if (selectedUser?.id)
      setFilter({
        ...filter,
        userId: selectedUser?.id,
      });
    else
      setFilter({
        ...filter,
        userId: "",
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedUser?.id]);

  const handleRemoveFilter = (f) => {
    let newFilter = { ...filter };
    Object.entries(newFilter).forEach(([k, v]) => {
      if (v === f) newFilter[k] = "";
    });
    setFilter(newFilter);
  };

  const handleOpenChat = (msg) => {
    setOpenChat(msg);
    const selectedChatData = chat?.find((el) => el.id === msg.id);
    const selectedStatus = selectedChatData ? selectedChatData.status : "";
    setStatus(selectedStatus);
  };

  const handleCloseChat = () => {
    setOpenChat(null);
  };

  const handleOpen = () => setOpenModal(true);
  const handleClose = () => {
    setOpenModal(false);
  };

  const handlSetreadConversation = (el) => {
    handleOpenChat(el);
    const bodyData = {
      conversationId: el.id,
    };
    if (role !== ROLE.USER) doSetreadConversation(bodyData);
    if (role === ROLE.USER) doSetreadUserConversation(el.id);
  };

  const handleRefecth = () => {
    if (role !== ROLE.USER) refetchChat();
    if (role === ROLE.USER) refetchChatUser();
  };

  const TABS_CHAT = [
    { label: "Generali", tab: "Generali" },
    { label: "Attività", tab: "Attività" },
  ];

  const filteredChat = chat?.filter((el) => {
    if (el.practiceId) {
      return selectedTab === "Attività";
    } else {
      return selectedTab === "Generali";
    }
  });

  return (
    <>
      {isLoadingChat ? (
        <CoreSpinner />
      ) : (
        <div className="flex flex-col">
          <div className="flex justify-between items-center">
            <div style={{ width: "100px" }}>
              <h2>{t("Chat")}</h2>
            </div>
            {appConfig?.modules?.practice?.general && (
              <CoreTabBar tab={TABS_CHAT} setSelectedTab={setSelectedTab} />
            )}
            {role !== ROLE.USER && (
              <div className="flex justify-end gap-4">
                {Object.entries(filter).map(
                  ([k, v]) =>
                    v !== "" &&
                    k !== "userId" && ( //per il filtro per utente direi di non usare il chip
                      <CoreChip
                        key={v}
                        label={labelForFilterChat(
                          k,
                          v,
                          operatorsData,
                          practicesData
                        )}
                        variant="outlined"
                        onDelete={() => handleRemoveFilter(v)}
                      />
                    )
                )}
                <ChatFilter
                  filter={filter}
                  setFilter={setFilter}
                  practices={practicesData}
                  isPracticesLoading={practicesLoading || practicesFetching}
                  setDebouncedInputPracticeValue={
                    setDebouncedInputPracticeValue
                  }
                  operators={operatorsData}
                  isOperatorsLoading={isOperatorsLoading || isOperatorsFetching}
                  setDebouncedInputOperatorValue={
                    setDebouncedInputOperatorValue
                  }
                />
              </div>
            )}
          </div>
          <div className="flex pb-4 space-x-4">
            <div className="">
              <CoreButtonHoverIcon
                onClick={handleRefecth}
                testo={t("Refresh")}
                className={`text-blue-500 m-1`}
                icon={<RefreshRoundedIcon className={`fill-blue-500`} />}
              />
              {appConfig?.modules?.chat?.settings && role !== ROLE.USER && (
                <CoreButtonHoverIcon
                  onClick={handleOpen}
                  className="text-slate-800  m-1"
                  icon={
                    <SettingsApplicationsRoundedIcon
                      className={`fill-slate-800   `}
                    />
                  }
                  testo={t("Settings")}
                />
              )}
            </div>
          </div>

          <div className="flex">
            <div
              className={
                openChat
                  ? "hidden xl:w-1/3 xl:inline"
                  : "h-full w-full xl:w-1/3"
              }
              style={{ maxWidth: "100%" }}
            >
              <div className="w-full h-fit">
                {role !== ROLE.USER && (
                  <UserFilter
                    size={true}
                    selectedUser={selectedUser}
                    setSelectedUser={setSelectedUser}
                    usersList={usersData?.Data?.items}
                    setDebouncedInputUserValue={setDebouncedInputUserValue}
                    isUsersLoading={isUsersLoading || isUsersFetching}
                    setPage={setPage}
                  />
                )}
              </div>
              <div className="h-fit">
                <ListaChat
                  chat={filteredChat?.length > 0 ? filteredChat : []}
                  onOpen={handleOpenChat}
                  loading={isLoadingChat || isLoadingChatUser}
                  onSetread={handlSetreadConversation}
                />
              </div>
            </div>

            <div
              className={`w-full xl:w-2/3 ${!openChat && "hidden xl:inline"}`}
              style={{
                border: "1px solid lightgrey",
              }}
            >
              {openChat ? (
                <div className="h-full ">
                  <div className="flex items-center justify-between ">
                    <h3
                      className="ml-4"
                      style={{
                        margin: "14px",
                      }}
                    >
                      {openChat?.userName}{" "}
                      {openChat.practiceId && ` | Attività: ${openChat.name}`}
                    </h3>
                    <CoreButtonIcon
                      className={"me-2"}
                      onClick={handleCloseChat}
                      icon={<CloseRoundedIcon color="error" />}
                    />
                  </div>
                  <Divider />

                  <ChatBox chatId={openChat.id} status={status} />
                </div>
              ) : (
                <p className="w-full h-full text-gray flex justify-center items-center m-0 ">
                  Nessuna chat selezionata
                </p>
              )}
            </div>
          </div>
        </div>
      )}

      {role !== ROLE.USER && (
        <div className="w-full flex justify-center py-5">
          <CorePagination
            page={page}
            setPage={setPage}
            totalPages={
              Math.ceil(dataChat?.Data?.count / TABLE_ROWS_NUMBER) || 1
            }
          />
        </div>
      )}

      <CoreModal
        width={"60%"}
        height={"70%"}
        state={openModal}
        onClose={handleClose}
        component={<AutoMessage onClose={handleClose} />}
      />
    </>
  );
};

export default ChatPage;
